function getBrowserName() {
  const userAgent = navigator.userAgent;
  let browserName = "";

  if (userAgent.includes("Chrome") && !userAgent.includes("Edge")) {
    browserName = "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browserName = "Safari";
  } else if (userAgent.includes("OPR")) {
    browserName = "Opera";
  }

  return browserName;
}

// Usage
export const browserName = getBrowserName();
